module.exports = __webpack_public_path__ + "static/media/surf3.a41fa025.svg";